import { useAuthStore } from '@modules/auth/stores/auth'
import { B2bPortalRight } from '@/enums/B2bPortalRight'

/** Pinia: check JWT portal right (delegates to auth store; null permissions = allow-all). */
export function piniaHasPortalRight(right: B2bPortalRight): boolean {
  return useAuthStore().hasRight(right)
}

export function piniaHasAnyPortalRight(rights: B2bPortalRight[]): boolean {
  const auth = useAuthStore()
  return rights.some((r) => auth.hasRight(r))
}
